import { mensajeSimple } from "../components/ui/sweetAlerts";
import { BASE_URL_PRODUCCION, objNoSuccess } from "../utils/Constants";
import { cerrarSession } from "../utils/funciones";
import Swal from "sweetalert2";
const OBTENER_DATOS_RUT_SOLICITANTE_EXITO = "OBTENER_DATOS_RUT_SOLICITANTE_EXITO";
const LOADING = "LOADING"

const dataInicial = {
  dataPersona: {
    rut: "",
    data: {},
    status: ""
  },
  loading: false
}

//reducer
export default function datosPersonaSolicitanteReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: true }
    case OBTENER_DATOS_RUT_SOLICITANTE_EXITO:
      return { ...state, dataPersona: action.payload, loading: false }
    default:
      return state;
  }
}

//accion de consumir api
const BASE_URL = BASE_URL_PRODUCCION;

export const obtenerDatosPersonaSolicitanteAction = (rutCompleto, idSolicitud = false) => async (dispatch, getState) => {
  dispatch({ type: LOADING });

  const params = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    }
  }

  try {
    const url = `${BASE_URL}/verificarpostulante?RutPersona=${rutCompleto}`;
    const response = await fetch(url, params);

    if (response.status === 401) {
      await Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: 'Tu sesión ha caducado. Serás redirigido para iniciar sesión nuevamente.',
        timer: 3000,
        showConfirmButton: false,
      });
      cerrarSession();
      return false;
    }

    if (!response.ok) {
      const errorMsg = objNoSuccess[response.status] || `Error inesperado (código ${response.status})`;
      mensajeSimple('error', errorMsg, 3500);
      return false;
    }

    const responseJSON = await response.json();

    if (responseJSON.status === "error") {
      mensajeSimple('error', responseJSON.message || 'Ocurrió un error al consultar el RUT.', 4000);
      return false;
    }
    if (responseJSON.status === "info") { mensajeSimple(responseJSON.status, responseJSON.message, 2500); }
    if (!responseJSON.data) { return false; }

    dispatch({
      type: OBTENER_DATOS_RUT_SOLICITANTE_EXITO,
      payload: {
        rut: rutCompleto,
        data: responseJSON.data,
        idSolicitud: idSolicitud,
        status: responseJSON.status,
        message: responseJSON.message
      }
    })

    return true
  } catch (error) {
    console.log("error :", error)
    console.log({error})
    return false
  }
}